import { css } from '@emotion/react';

import { colors } from '../../styles/colors';
import { ZeeFontMedium } from '../../styles/font';
import { flex } from '../../styles/utils';

const delay = 0.22;

export const fadeIn = css`
  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
  animation-duration: ${delay}s;
  animation-name: fadeIn;
`;
export const fadeOut = css`
  @keyframes fadeOut {
    from {
      opacity: 1;
    }
    to {
      opacity: 0;
    }
  }
  animation-duration: ${delay}s;
  animation-name: fadeOut;
`;

export const slideIn = css`
  @keyframes slideIn {
    from {
      transform: translateX(100%);
    }
    to {
      transform: translateX(0%);
    }
  }
  animation-duration: ${delay}s;
  animation-name: slideIn;
`;

export const slideOut = css`
  @keyframes slideOut {
    from {
      transform: translateX(0%);
    }
    to {
      transform: translateX(100%);
    }
  }
  animation-duration: ${delay}s;
  animation-name: slideOut;
`;

export const outlineButton = css`
  background: transparent;
  border: 1px solid ${colors.PrimaryWhiteColor};
  border-radius: 6px;
  color: ${colors.PrimaryWhiteColor};
  padding: 12px 27px;
  ${flex()};
  ${ZeeFontMedium(14, 22)}
`;

export const overlay = css`
  position: fixed;
  width: 100vw;
  color: ${colors.PrimaryWhiteColor};
  top: 0;
  left: 0;
  z-index: 1000;
`;

export const defaultOverlay = css`
  height: 100vh;
  background: ${colors.PortalTransparentBg};
`;

export const MobileMenuHeader = css`
  ${flex()};
  padding: 8px;
  background-color: ${colors.AppBgColor};
`;

export const CloseButton = css`
  background: none;
  border: none;
  color: ${colors.PrimaryWhiteColor};
`;

export const Zee5LogoContainer = css`
  ${flex()};
  width: 100%;
`;

export const Zee5Logo = css`
  width: 40px;
  height: 40px;
`;

export const buttonsContainer = css`
  ${flex()};
  gap: 27px;
  padding: 10px;
  background-color: ${colors.PrimaryWhiteColorAlpha10};
`;
